__turbopack_context__.v({
  "canvas": "Waveform-module__wG7Jyq__canvas",
});
